
/**
 * TextStylesProcessor - Creates styles for text elements
 */
export class TextStylesProcessor {
  static createTextStyles(): string {
    return `
      /* Text styles */
      .onexip-calculator-container .text-sm {
        font-size: 0.875rem !important;
      }

      .onexip-calculator-container .font-medium {
        font-weight: 500 !important;
      }

      .onexip-calculator-container .text-primary {
        color: #FB923C !important;
      }

      .onexip-calculator-container .text-muted-foreground {
        color: #64748b !important;
      }
    `;
  }
}
